type JobStep = {
  ended_at: string | null;
  estimated_seconds: number;
  started_at: string | null;
  status: JobStatus;
  status_text: string;
  step_name: string;
};

interface JobMeta {
  steps: JobStep[];
}

interface JobDetails<Result, Metadata extends JobMeta = JobMeta> {
  created_at: string;
  ended_at: string | null;
  enqueued_at: string | null;
  job_id: string;
  metadata: Metadata;
  result: Result | null;
  started_at: string | null;
  status: JobStatus;
  status_text: string;
}

type JobStatus = "started" | "finished" | "queued" | "failed";

export { JobDetails, JobMeta, JobStatus, JobStep };
